import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisApi = ApiDefinition['/sockets/broadcast']['POST'];
type Input = ThisApi['body'];
type Output = ThisApi['response'];

const broadcastSocketMessage = async ({ channel, data, type }: Input): Promise<Output> => {
  const response = await noodleApiClient.post('/sockets/broadcast', { channel, data, type });
  return response.data;
};

export default broadcastSocketMessage;
